export interface ApplicationFilter {
  value: string;
  label: string;
}

export const APPLICATION_FILTERS: ApplicationFilter[] = [
  { value: "", label: "All" },
  { value: "IBP", label: "IBP" },
  { value: "Mosaic", label: "Mosaic" },
];

export function getApplicationTags(application?: string | null): string[] {
  const seen = new Set<string>();
  const tags: string[] = [];
  for (const raw of String(application || "").split(/[;,/|]+/)) {
    const lower = raw.trim().toLowerCase();
    if (!lower || seen.has(lower)) continue;
    seen.add(lower);
    if (lower === "ibp") tags.push("IBP");
    else if (lower === "mosaic") tags.push("Mosaic");
    else tags.push(raw.trim());
  }
  return tags;
}

export function hasApplicationTag(application?: string | null, appFilter?: string | null): boolean {
  if (!appFilter) return true;
  return getApplicationTags(application).some((tag) => tag.toLowerCase() === appFilter.toLowerCase());
}

export function inferIberiaApplication(sourceDataset?: string | null): string {
  const normalized = String(sourceDataset || "").trim().toLowerCase();
  if (!normalized) return "IBP";
  if (normalized.includes("mosaic")) return "Mosaic";
  if (normalized === "aop-bu" || normalized === "aop-pnl") return "Mosaic";
  if (normalized === "customer master") return "IBP; Mosaic";
  return "IBP";
}